import { render, staticRenderFns } from "./AbaDadosCadastrais.vue?vue&type=template&id=fafe6aa0&scoped=true"
import script from "./AbaDadosCadastrais.vue?vue&type=script&lang=js"
export * from "./AbaDadosCadastrais.vue?vue&type=script&lang=js"
import style0 from "./AbaDadosCadastrais.vue?vue&type=style&index=0&id=fafe6aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafe6aa0",
  null
  
)

export default component.exports